import { AppRoutes } from "@/shared/lib/routes"
import { useNavigateWithParams, useHrefWithParams } from "@/shared/hooks/use-navigate-with-params"

import { REFUND_MAILTO } from "../config/landing-content"
import { AdvantagesSection } from "./sections/advantages-section"
import { AstrologerSection } from "./sections/astrologer-section"
import { HowItWorksSection } from "./sections/how-it-works-section"
import { IntroSection } from "./sections/intro-section"
import { OutroSection } from "./sections/outro-section"
import { ReviewsSection } from "./sections/reviews-section"
import { ToolsSection } from "./sections/tools-section"

/**
 * Marketing landing page (route `/`). Every primary call-to-action funnels into
 * the quiz (`/quiz`); the header "Sign in" goes to `/signin`, "Ask for refund"
 * opens a support email, and the footer links go to the real legal pages. Query
 * params are preserved across navigations. Sections stay dumb and presentational.
 */
export function LandingPage() {
  const navigate = useNavigateWithParams()
  const href = useHrefWithParams()

  const goToQuiz = () => navigate({ to: AppRoutes.QUIZ })
  const goToSignIn = () => navigate({ to: AppRoutes.SIGN_IN })

  const footerLinks = [
    { label: "Privacy Policy", href: href(AppRoutes.PRIVACY) },
    { label: "Terms of use", href: href(AppRoutes.TERMS) },
    { label: "Cookie Policy", href: href(AppRoutes.COOKIES) },
    { label: "Ask for refund", href: REFUND_MAILTO },
  ]

  return (
    <div
      className="min-h-[100dvh] w-full overflow-x-hidden bg-dark-base text-purple-light"
      style={{ fontFamily: '"Red Hat Text Variable", sans-serif' }}
    >
      <div className="mx-auto flex w-full max-w-app flex-col">
        <IntroSection onAction={goToQuiz} onSignIn={goToSignIn} />

        <div className="flex flex-col gap-10 py-10">
          <ToolsSection onAction={goToQuiz} />
          <AstrologerSection onAction={goToQuiz} />
          <AdvantagesSection onAction={goToQuiz} />
          <ReviewsSection />
          <HowItWorksSection onAction={goToQuiz} />
        </div>

        <OutroSection footerLinks={footerLinks} />
      </div>
    </div>
  )
}
